import React from 'react';

const formatCurrency = value => {
    if (!value || isNaN(value)) return '0 €';
    return parseFloat(value).toLocaleString('es-ES', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 2 
    }) + ' €';
};

const InvestmentSummary = ({ costeReforma, costesExtra, propiedadId }) => {
    const precioCompra = propiedadId ? 213000 : 0;
    const inversionTotal = precioCompra + parseFloat(costeReforma) + (costesExtra || 0);

    return (
        <div className="border-t pt-4">
            <h3 className="font-semibold text-gray-700 mb-3">💰 Resumen de Inversión</h3>
            <div className="bg-gray-50 p-4 rounded">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <span className="text-sm text-gray-600">Precio de Compra:</span>
                        <div className="font-bold text-lg">{formatCurrency(precioCompra)}</div>
                    </div>
                    <div>
                        <span className="text-sm text-gray-600">Inversión Total:</span>
                        <div className="font-bold text-lg text-red-600">{formatCurrency(inversionTotal)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvestmentSummary; 